
import adminService from "@/services/admin.service"
import { mdiDotsHorizontal, mdiDelete } from "@mdi/js"
export default {
    name: "SubscriptionMenu",
    props: {
        business: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        subscriptionTypes: {
            type: Array,
            default: () => [],
        },
    },
    icons: {
        mdiDotsHorizontal,
        mdiDelete,
    },
    data() {
        return {
            fab: false,
            channels: [],
            isLoadingChannels: false,
            isLoadingSubscriptions: false,
            selectedSubscription: null,
        }
    },
    methods: {
        async removeSubscriptionType(subscriptionId) {
            this.isLoadingSubscriptions = true
            let business = await adminService.removeBusinessSubscriptionType(
                this.business.slug,
                subscriptionId
            )
            if (business) {
                this.$emit("updated", business)
            }
            this.isLoadingSubscriptions = false
        },
        async setSubscriptionType(subscriptionId) {
            this.isLoadingSubscriptions = true
            let business = await adminService.addSubscription(
                this.business.slug,
                subscriptionId
            )
            if (business) {
                this.$emit("updated", business)
            }

            this.selectedSubscription = null
            this.isLoadingSubscriptions = false
        },
    },
}
